import type { Environment } from "../types";

type ProcessWithNextPublicEnv = {
  env?: {
    NEXT_PUBLIC_CROSSX_ENVIRONMENT?: string;
    CROSSX_ENVIRONMENT?: string;
  };
};

declare const process: ProcessWithNextPublicEnv | undefined;

type MaybeViteEnv = {
  env?: Record<string, string | undefined>;
};

function readViteEnv(key: string): string | undefined {
  try {
    return (import.meta as unknown as MaybeViteEnv).env?.[key];
  } catch {
    return undefined;
  }
}

function readNodeEnv(key: string): string | undefined {
  if (typeof process === "undefined") return undefined;
  return process.env?.[key as keyof NonNullable<ProcessWithNextPublicEnv["env"]>];
}

export function resolveEnvironment(
  env?: Environment | "staging" | "prd" | "prod" | "stg",
): Environment {
  if (env) return normalizeEnvironment(env);

  const crossxEnv =
    readViteEnv("VITE_CROSSX_ENVIRONMENT") ??
    readViteEnv("NEXT_PUBLIC_CROSSX_ENVIRONMENT") ??
    readNodeEnv("NEXT_PUBLIC_CROSSX_ENVIRONMENT") ??
    readNodeEnv("CROSSX_ENVIRONMENT");

  return normalizeEnvironment(crossxEnv);
}

function normalizeEnvironment(value: string | undefined): Environment {
  switch (value?.toLowerCase()) {
    case "dev":
    case "development":
      return "dev";
    case "stage":
    case "staging":
    case "stg":
      return "stage";
    case "production":
    case "prod":
    case "prd":
    default:
      return "production";
  }
}
